module.exports = __webpack_public_path__ + "static/media/default-user.5405d77c.png";